import { render, staticRenderFns } from "./EformElementEditDateDefaultNow.vue?vue&type=template&id=633121e3&scoped=true&"
import script from "./EformElementEditDateDefaultNow.vue?vue&type=script&lang=js&"
export * from "./EformElementEditDateDefaultNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633121e3",
  null
  
)

export default component.exports